import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { useFields } from './fields';
import { CreateUpdateContainer } from '../../components/CreateUpdateContainer/CreateUpdateContainer';
import { useAuthContext } from '../../contexts/AuthContext';

export const CreateUpdateUser = ({ purpose }) => {
  const { t } = useTranslation();
  const { fields, isFieldsLoading, base64 } = useFields();
  const { user, setUser } = useAuthContext();

  const config = {
    onCreateResource: {
      setBody: (data) => ({
        ...data,
        ...(base64 ? { photo: base64 } : {}),
        role: 'admins:ADMIN'
      })
    },
    onGetResource: {
      setFields: (data) => ({
        ...data,
        date_of_birth: data.date_of_birth && dayjs(data.date_of_birth)
      })
    },
    onUpdateResource: {
      setBody: (data) => {
        if (data._id === user._id) setUser({ ...user, ...data });
        return {
          ...data,
          ...(base64 ? { photo: base64 } : {}),
          role: 'admins:ADMIN'
        };
      }
    }
  };

  return (
    <CreateUpdateContainer
      withPageHeaderCustom
      fields={fields}
      fieldsCardTitle={t('users.show.card_title')}
      fieldsCardIcon="user"
      loadingFields={isFieldsLoading}
      purpose={purpose}
      baseUrl="users"
      resource="users"
      config={config}
    />
  );
};

CreateUpdateUser.propTypes = {
  purpose: PropTypes.string.isRequired
};
